import { CALL_API } from 'middlewares/api';
import { url } from 'configs/';
import fetchData from 'utils/api';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_USER_TREEVIEWS_REQUEST = 'tube/companyrules/user/FETCH_USER_TREEVIEWS_REQUEST';
const FETCH_USER_TREEVIEWS_SUCCESS = 'tube/companyrules/user/FETCH_USER_TREEVIEWS_SUCCESS';
const FETCH_USER_TREEVIEWS_FAILURE = 'tube/companyrules/user/FETCH_USER_TREEVIEWS_FAILURE';
const FETCH_USER_VIEW_REQUEST = 'tube/companyrules/user/FETCH_USER_VIEW_REQUEST';
const FETCH_USER_VIEW_SUCCESS = 'tube/companyrules/user/FETCH_USER_VIEW_SUCCESS';
const FETCH_USER_VIEW_FAILURE = 'tube/companyrules/user/FETCH_USER_VIEW_FAILURE';

export default function reducer(state = {
  rulesList: [],
  rules: {},
  error: {},
  meta: {}, // 分頁資訊
  isGridFetching: false,
}, action) {
  switch (action.type) {
    case FETCH_USER_TREEVIEWS_FAILURE:
      {
        return Object.assign({}, state, {
          error: action.error,
          isGridFetching: false,
        });
      }
    case FETCH_USER_TREEVIEWS_REQUEST:
      {
        return Object.assign({}, state, {
          isGridFetching: true,
        });
      }
    case FETCH_USER_TREEVIEWS_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let list = [];
        let meta = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          list = action.response.data;
          meta = action.response.meta;
        }
        return Object.assign({}, state, {
          rulesList: list,
          isGridFetching: false,
          meta,
        });
      }
    case FETCH_USER_VIEW_SUCCESS:
      {
        const httpStatusCode = Number(action.response.meta.httpStatusCode);
        let data = {};
        if (httpStatusCode === 200 && action.response.hasOwnProperty('data')) {
          data = action.response.data;
        }
        return Object.assign({}, state, {
          rules: data,
        });
      }
    default:
      return state;
  }
}
/* 列表樹狀資料查詢(使用者畫面) */
export function fetchUserTreeViews(keyword) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/TreeView`,
      method: 'GET',
      types: [
        FETCH_USER_TREEVIEWS_REQUEST,
        FETCH_USER_TREEVIEWS_SUCCESS,
        FETCH_USER_TREEVIEWS_FAILURE,
      ],
      params: keyword,
    },
  };
}

/* 分類單筆查詢(使用者畫面) */
export function fetchUserView(companyRegulationsId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}Tube_Regulations/Regulation/${companyRegulationsId}`,
      method: 'GET',
      types: [
        FETCH_USER_VIEW_REQUEST,
        FETCH_USER_VIEW_SUCCESS,
        FETCH_USER_VIEW_FAILURE,
      ],
    },
  };
}
/* 下載附件 */
export function downloadEnrollAttachment(apiUrl) {
  const fetchOptions = {
    mode: 'cors',
    method: 'GET',
    headers: {},
  };
  let downloadUrl = apiUrl.split('api/')[1];
  fetchOptions.headers['Content-Type'] = 'application/json';
  downloadUrl = `${NEWTUBE_API_SERVER}${downloadUrl}`;
  return fetchData(downloadUrl, fetchOptions);
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanyRules/screens/User/reducers/index.js
 **/